<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <c-search-form :input-search-items="searchItems"
                       :form-name="formName"
                       :hiddenFields="hiddenFields"
                       model="searchForm" :fields="fields"
                       key-property="logId"
                       :search-url="searchUrl"
                       :accept-create="false"
                       :accept-delete="false"
                       @showImage="showImage"
                       :acceptExport="1"
                       @dowloadImage="dowloadImage"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Log BabiSchool All",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phoneNumber",
          label: "Nhập List ID dạng 2451566;2451856",
          placeHolder: "",
          focus: true
        },
      ],
      hiddenFields: {
        fromDate: null,
        toDate: null,
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'Account Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberAcc',
          text: 'Số điện thoại đăng ký',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberOrder',
          text: 'Số điện thoại mua hàng',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        /*        {
                  value: 'isCheckAccount',
                  text: 'Mô tả',
                  width: "5%",
                  sortable: false,
                  headerStyle: "text-align:left"
                },*/
        {
          value: 'createDate',
          text: 'Ngày học',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'createDate',
          text: 'Giờ học',
          sortable: false,
          search: false,
          dateFormat: 'hh:mm:ss',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'lessonName',
          text: 'Bài Học',
          sortable: false,
          search: false,
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'point',
          text: 'Kết quả học',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        }
      ]
    }
  },
  methods: {
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    clearFromDate() {
      this.hiddenFields.fromDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.toDate = new Date();
    },
  },
  created() {
    this.searchUrl = "/babiAccountClass/searchAllLogBabiSchool?sortField=status,classId&";
  },


}
</script>
